import {
  DbotEventDispatcher,
  DecisionContext,
  DecisionTypeHandler,
} from "@/dbot/common/commonDomain";
import { LiquidateCompany, LiquidateCompanyForm } from "./liquidateCompanyDomain";
import { DecisionType } from "@/common/decisions";

export function initNewForm(
  _dispatch: DbotEventDispatcher,
  context: DecisionContext<LiquidateCompany>,
  data?: LiquidateCompany,
): LiquidateCompanyForm {
  return new LiquidateCompanyForm(context, data);
}

export function applyForm(form: LiquidateCompanyForm): LiquidateCompany {
  return {
    type: DecisionType.liquidateCompany,
    isDissolutionResolved: form.isDissolutionResolved.value,
    isCreditorNoticeExpired: form.isCreditorNoticeExpired.value,
    dissolutionGeneralMeetingDate: form.dissolutionGeneralMeetingDate,
    isFinalSettlementAudited: form.isFinalSettlementAudited.value,
  };
}

export function validate(form: LiquidateCompanyForm): boolean {
  return form.validate();
}

export function isValid(form: LiquidateCompanyForm): boolean {
  return form.isValid;
}

export const liquidateCompanyHandler: DecisionTypeHandler<
  DecisionType.liquidateCompany,
  LiquidateCompany,
  LiquidateCompanyForm
> = {
  type: DecisionType.liquidateCompany,
  initNewForm,
  isValid,
  validate,
  applyForm,
};
